
module.exports = {
	CACHE_SURVEY_STATE: "CACHE_SURVEY_STATE",
	GO_PREVIOUS_SURVEY_STATE: "GO_PREVIOUS_SURVEY_STATE"
};



// WEBPACK FOOTER //
// ./src/common/modules/surveyStateHistory/constants.js